import { Route, createPageRoute } from '@lumapps/router';
import { AppId } from '@lumapps/router/constants';

export const mediaTrashRoute: Route = createPageRoute({
    slug: 'media/trash',
    appId: AppId.backOffice,
});
